<div class="sx-spinner__wrapper" [ngClass]="{'sx-spinner__wrapper__small': showSmall}">
  <mat-spinner class="sx-spinner"></mat-spinner>
</div>
<div *ngIf="text !==''" class="sx-spinner__preload-text">{{text}}</div>